import { render, staticRenderFns } from "./Ozon.vue?vue&type=template&id=1081ff24&"
import script from "./Ozon.vue?vue&type=script&lang=js&"
export * from "./Ozon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports